import {useState} from 'react'
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Stack,
  Typography
} from '@mui/material'
import {useFormContext} from 'react-hook-form'
import ReactSignatureCanvas from 'react-signature-canvas'
import CheckBox from 'src/components/ui/Checkbox'
import {resolve} from 'src/utils/utils'
import FormTextField from 'src/components/ui/TextField'

const SignaturePad = ReactSignatureCanvas as unknown as React.ComponentType<any>

const name = 'signature'
const commitmentConfirmationField = 'isCommitmentConfirmation'
const commitmentText =
  'אני החתום מטה מתחייב בזאת שכל הפרטים שלעיל, ופרטי הלומדים הרשומים בדו”ח המצורף, נכונים ומדויקים נכון לתאריך בו הוגשה הבקשה, ובאם יהיו שינויים מתחייב לעדכן את קרנה של תורה מיידי. ומודע לכך שבמקרה של אי הקפדה על פרטים מדויקים ועדכונים לא יהיה לקרנה של תורה ברירה אלא לחייבו בהחזרת כל התמיכה שהועברה על ידה.'

const Commitment: React.FC = () => {
  const {
    trigger,
    setValue,
    formState: {errors},
    clearErrors
  } = useFormContext()

  const error: any = resolve(name, errors)

  const [sigCanvas, setSigCanvas] = useState<ReactSignatureCanvas | null>(null)

  const clear = () => {
    sigCanvas?.clear()
    setValue(name, null)
  }

  const revalidate = (fieldId: string) => {
    setTimeout(() => {
      trigger(fieldId)
    }, 100)
  }

  const onSign = () => {
    clearErrors(name)
    setValue(name, sigCanvas?.getTrimmedCanvas().toDataURL('image/png'))
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h6">הערות:</Typography>
      <Stack>
        <FormTextField
          label=""
          name="externalNote"
          multiline
          rows={4}
          fullWidth
          placeholder="הכנס כאן את ההערות שלך... "
        />
      </Stack>
      <Typography variant="h6">התחייבות:</Typography>
      <Stack spacing={1}>
        <Typography
          sx={{
            color: 'error.main',
            fontWeight: 800,
            fontSize: {xs: '1.05rem', md: '1.35rem'},
            lineHeight: 1.8
          }}
        >
          שדה חובה *
        </Typography>
        <CheckBox
          name={commitmentConfirmationField}
          required
          label={
            <Typography
              sx={{
                color: 'error.main',
                fontWeight: 800,
                fontSize: {xs: '1.05rem', md: '1.35rem'},
                lineHeight: 1.8
              }}
            >
              {commitmentText}
            </Typography>
          }
          onChange={() => revalidate(commitmentConfirmationField)}
        />
      </Stack>
      <FormControl error={!!error}>
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <FormLabel color="primary">
            לשם השלמת התהליך, נא לצייר חתימה דיגיטלית תואמת לחתימתך הרשמית
          </FormLabel>
          <Button color="inherit" onClick={clear}>
            נקה
          </Button>
        </Stack>
        <Stack border={1}>
          <SignaturePad
            ref={setSigCanvas}
            penColor="black"
            onEnd={onSign}
            canvasProps={{height: 130}}
          />
        </Stack>
        <FormHelperText error={!!error}>{error?.message}</FormHelperText>
      </FormControl>
    </Stack>
  )
}

export default Commitment
